import { Injectable } from '@angular/core';
import * as global_var from '../../global.variable';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  constructor(private http: HttpClient, private router: Router) {}

  setHeader() {
    return this.http.post(global_var.apiUrl + 'setheader', {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
